export default __webpack_public_path__ + "static/media/troy_footer.b7223ae3.png";